import React from 'react';
import PropTypes from 'prop-types';

import ReportDataTabs from './ReportDataTabs';
import ReportDataTab from './ReportDataTab';

const ReportData = ({
  reportData,
  tabNames,
  activeTabIndex,
  selectTab,
}) => (
  <div className="o-flexbox o-flexbox--justify-start o-flexbox--content-align-start o-flexbox--no-wrap">
    <ReportDataTabs
      tabNames={tabNames}
      activeTabIndex={activeTabIndex}
      onSelectTab={selectTab}
    />
    <ReportDataTab
      tabName={tabNames[activeTabIndex]}
      tabData={reportData[activeTabIndex] ? reportData[activeTabIndex].data : []}
    />
  </div>
);

ReportData.propTypes = {
  reportData: PropTypes.arrayOf(PropTypes.object).isRequired,
  tabNames: PropTypes.arrayOf(PropTypes.string).isRequired,
  activeTabIndex: PropTypes.number.isRequired,
  selectTab: PropTypes.func.isRequired,
};

export default ReportData;
